import { useColors } from 'ComponentLibrary'
import { useSearchParams } from 'react-router-dom'

export function useSelectedAssets() {
    const [searchParams, setSearchParams] = useSearchParams()
    const { getColor } = useColors() // TODO: use the backend endpoint to get gesammt value for selectedAssets
    // Get list of assets from searchparams
    const selectedAssets = searchParams.get('assets')?.split(',') ?? []
    const getAssetColor = (index: number, darker?: boolean) => {
        // Darker is used for border colors and for hover effects
        const baseOpacity = darker ? 0.55 : 0.25
        // To enable as many assets as possible to be visible, we use an opacity gradient
        return getColor(index, false, baseOpacity + Math.floor(index / 10) * 0.1)
    }

    const toggleAsset = (assetId: string) => {
        if (assetId === 'summary') {
            setSearchParams({})
        } else {
            const newSelectedAssets = selectedAssets.includes(assetId)
                ? selectedAssets.filter((id) => id !== assetId)
                : [...selectedAssets, assetId]
            newSelectedAssets.length > 0 ? setSearchParams({ assets: newSelectedAssets.join(',') }) : setSearchParams({})
        }
    }
    return {
        selectedAssets,
        toggleAsset,
        getAssetColor,
    }
}

export default {
    useSelectedAssets,
}
